import { GSFormField } from './form-field';
import validationTests from './validation-tests';


import autosize = require('autosize');

export class GSFormFieldTextarea extends GSFormField {

	//
	// Properties
	//

	private initialValue;
	private tests;

	get type()    { return 'textarea'; }
	get isDirty() { return this.value !== this.initialValue; }
	get isValid() { return !this.root.hasClass('is-invalid'); }
	set isValid(value) { this.root.toggleClass('is-invalid', !value); }

	get validationRegex()  { return this.input.data('gsFormFieldValidationRegex'); }
	set validationRegex(value) { this.input.data('gsFormFieldValidationRegex', value); }

	//
	// Methods
	//

	validate() {
		let failedTest = this.tests
			.find(test => !test.test(this.value));

		if (failedTest) {
			this.isValid = false;
			this.root.addClass(failedTest.invalidClass);
			this.input.on('keyup.validate', () => this.revalidate(failedTest));
		}

		return !failedTest;
	}

	private revalidate(failedTest) {
		if (failedTest.test(this.value)) {
			this.isValid = true;
			this.root.removeClass(failedTest.invalidClass);
			this.input.off('keyup.validate');
		}
	}

	private setValidationTests() {
		this.tests = [
			...validationTests.filter(test => this.root.hasClass(test.checkClass)),
			{ invalidClass: 'is-invalid-regex', test: value => this.testRegex(value) }
		];
	}

	private testRegex(value) {
		if (!this.validationRegex) return true;
		let pattern = new RegExp(this.validationRegex);
		return pattern.test(value);
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		super(root);
		autosize(this.input);
		this.setValidationTests();
		this.initialValue = this.value;
	}

	gsOnDestroy() {
		this.input.off();
		autosize.destroy(this.input);
	}
}
